module.exports = __webpack_public_path__ + "static/media/light-theme-unique-geofence.c7970033.svg";